import Button from "@material-ui/core/Button";
import classnames from "classnames";

import { GreenButtonProps } from "./green-button.props";
import { useGreenButtonStyle } from "./green-button.style";

export const GreenButton = (props: GreenButtonProps) => {
  const { marginAround = false, ...rest } = props;
  const classes = useGreenButtonStyle();

  const className = classnames({
    [classes.button]: true,
    [classes.disabled]: rest.disabled,
    [classes.marginAround]: marginAround,
    [props.className!]: Boolean(props.className),
  });

  return <Button {...rest} className={className} />;
};
